import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import fieldsValidator from 'library/helpers/validators/fieldsValidator';
import React, { useEffect, useState } from 'react';
import { Button, Flex, Form, Input, Tooltip } from 'zui/Antd';

const RenderMultiValue = ({ setting, settings, index, setSettings, canEditSettings }) => {
	const [form] = Form.useForm();
	const [options, setOptions] = useState([]);

	useEffect(() => {
		setOptions(setting.value || []);
	}, [setting]);

	useEffect(() => {
		const fieldsValue = options.reduce((acc, option) => {
			acc[option.name] = option.value;
			return acc;
		}, {});
		form.setFieldsValue(fieldsValue);
	}, [options, form]);

	const onValuesChange = (changedValues, allValues) => {
		const allLabelsFilled = Object.keys(allValues).every((field) => field.trim() !== '');

		const enrichArrayWithValues = (obj, arr) => {
			return arr.map((item) => ({
				...item,
				value: obj[item.name]
			}));
		};

		const finalValue = enrichArrayWithValues(allValues, options);

		const updatedSettings = [...settings];
		updatedSettings[index] = {
			...setting,
			value: allLabelsFilled ? finalValue : null
		};
		setSettings(updatedSettings);
	};

	const handleAddOption = () => {
		const newId = options.length + 1;
		setOptions([...options, { id: newId, name: `string${newId}`, value: '' }]);
	};

	const handleDeleteOption = (id) => {
		setOptions(options.filter((option) => option.id !== id));
		const updatedSettings = [...settings];
		updatedSettings[index] = {
			...setting,
			value: options.filter((option) => option.id !== id)
		};
		setSettings(updatedSettings);
	};

	return (
		<Tooltip title={!canEditSettings ? "You don't have permission to edit settings" : ''}>
			<Form form={form} onValuesChange={onValuesChange} style={{ width: '100%' }}>
				{options.map(({ id, name }) => (
					<Flex key={id} gap={10} flex={1}>
						<Form.Item name={name} rules={fieldsValidator.String} style={{ flex: 1 }}>
							<Input placeholder='Enter String' disabled={!canEditSettings} />
						</Form.Item>
						<Button
							type='text'
							onClick={() => handleDeleteOption(id)}
							icon={<CloseCircleOutlined />}
							disabled={!canEditSettings}
						/>
					</Flex>
				))}
				<Form.Item style={{ margin: 0 }}>
					<Button
						type='dashed'
						onClick={handleAddOption}
						block
						icon={<PlusOutlined />}
						disabled={!canEditSettings}
					>
						Add Custom Field
					</Button>
				</Form.Item>
			</Form>
		</Tooltip>
	);
};

export default RenderMultiValue;
